import endpoints, { axios } from "../config/api";

async function getCommercialTemplates() {
  const response = await axios.get(endpoints.commercials.get);
  return response.data;
}

export default getCommercialTemplates;
